import React from 'react'

import commaSeparetedValue from '../../../../../helpers/commaSeparetedValue'
import Image from './Image'
import Details from './Details'
import Quantity from './Quantity'
import VehicleFitment from './VehicleFitment'
import RemoveFromCart from './RemoveFromCart'
import DeliveryDates from './Details/DeliveryDates'
import FreeShippingBadge from './FreeShippingBadge'
import InstallAtShopWrapperCart from '../../../../DIFM/InstallAtShop/InstallAtShopWrapperCart'
import {
  StyledDesktopContainer,
  StyledPrice,
  StyledPriceAndRemoveContainer,
  StyledWidgetsContainer,
  StyledImageContainer,
} from './ItemDesktopWmo.css'
import Core from './Details/Core'
import ProductProtection from './ProductProtection/ProductProtection'
import { FreeShippingBadgeV2 } from '../../../../FreeShippingBadge/FreeShippingBadgeV2'
import { PromoBadge } from '../../../../PromoBadge'
import { ItemLoader } from './ItemLoader'

const ItemDesktopWmo = ({
  data,
  index,
  itemTotal,
  handleAddVehicle,
  lastSkuEta,
  trackSelectItem,
  promoBadgeConfig,
  isPromoBadgeEnabled,
  showLoader,
  zipCode,
  isFitmentVisible,
}) => (
  <StyledDesktopContainer>
    <ItemLoader
      showLoader={showLoader}
      currentItemProductId={data?.product?.productId}
    />
    <StyledImageContainer>
      {(!isPromoBadgeEnabled) && (
        <FreeShippingBadge data={data} />
      )}
      <Image data={data} trackSelectItem={trackSelectItem} />
      {isPromoBadgeEnabled && (
        <FreeShippingBadgeV2 data={data} />
      )}
      {(isPromoBadgeEnabled && data?.product?.pricingStatus?.isPromo) && (
        <PromoBadge data={{ pageType: 'cart', sku: data?.product?.sku }} config={promoBadgeConfig} />
      )}
    </StyledImageContainer>

    <div>
      <Details data={data} index={index} trackSelectItem={trackSelectItem} />
      <Core data={data} index={index} />
      <DeliveryDates data={data} dataTestId="desktop-see-all-dates-cart" zipCode={zipCode} />

      <StyledWidgetsContainer>
        {isFitmentVisible && <VehicleFitment data={data} />}
        {(data?.productWarranty && data?.productWarranty?.productProtectionPlan.length > 0) && (
          <ProductProtection data={data} />
        )}
        <InstallAtShopWrapperCart
          cartItemData={data}
          addVehicleTrigger={handleAddVehicle}
          lastSkuEta={lastSkuEta}
        />
      </StyledWidgetsContainer>
    </div>

    <div>
      <Quantity data={data} index={index} />
    </div>

    <StyledPriceAndRemoveContainer>
      <StyledPrice>
        $
        {commaSeparetedValue(itemTotal)}
      </StyledPrice>

      <RemoveFromCart data={data} index={index} />
    </StyledPriceAndRemoveContainer>
  </StyledDesktopContainer>
)

export default ItemDesktopWmo
